import React, { Component, Fragment } from 'react';

import { AnalysesList } from './AnalysesList';
import Can from '../Can';
import { Error } from '../shared/Error/Error';
import { LoadingIndicator } from '../shared/LoadingIndicator/LoadingIndicator';
import Pager from '../shared/Pager/Pager';
import PropTypes from 'prop-types';
import { VALID_ANALYSIS_STATUSES } from '../../helpers/Analysis';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchAnalyses } from '../state/actions/AnalysisActions';
import { setSearch } from '../state/actions/SearchActions';

// COMPONENT
class AnalysesBrowser extends Component {
    componentDidMount() {
        this.props.fetchAnalyses();
        this.setState({ status: '' });
    }

    handlePageClick = data => {
        const { pageNumber } = data;
        const { pageSize } = this.props.paging;
        const { search } = this.props;

        this.props.fetchAnalyses(search, this.state.status, pageNumber, pageSize);
    };

    onSetSearch = event => {
        const { value: search } = event.target;
        const { setSearch } = this.props;
        setSearch(search);
    };

    onSearchClick = () => {
        const { search } = this.props;
        const { pageSize } = this.props.paging;

        this.props.fetchAnalyses(search, this.state.status, 1, pageSize);
    };

    onSearchSubmit = event => {
        // Without this the form does a native GET submit when Enter is pressed in the search
        // box: the browser navigates to /analyses?, the app remounts, and componentDidMount
        // refetches with no search term, so every analysis comes back unfiltered.
        event.preventDefault();
        this.onSearchClick();
    };

    onStatusChange = event => {
        const { search } = this.props;
        const { pageSize } = this.props.paging;

        const { value: status } = event.target;
        this.setState({ status: status });

        this.props.fetchAnalyses(search, status, 1, pageSize);
    };

    render() {
        const { analyses, fetched, fetching, failed } = this.props;

        if (!fetched) {
            return <LoadingIndicator busy={fetching} />;
        } else if (failed) {
            return <Error message="Failed to fetch analysis records" />;
        } else {
            const { pages, pageNumber } = this.props.paging;

            const { search } = this.props;
            const { status } = this.state ? this.state : '';

            return (
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between">
                            <h4 className="card-title">Analysis Reports</h4>
                            <div>
                                <label htmlFor="status" className="mr-sm-2">
                                    Status
                                </label>
                                <select
                                    id="status"
                                    onChange={this.onStatusChange}
                                    value={status ? status : ''}
                                >
                                    <option key="" value="">
                                        --
                                    </option>
                                    {Object.values(VALID_ANALYSIS_STATUSES).map(option => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <form className="form-inline" onSubmit={this.onSearchSubmit}>
                                    <input
                                        className="form-control form-control-sm mr-sm-2"
                                        placeholder="Search"
                                        value={search}
                                        onChange={this.onSetSearch}
                                        type="text"
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary"
                                        onClick={this.onSearchClick}
                                    >
                                        Search
                                    </button>
                                </form>
                            </div>
                        </div>
                        <Can I="read" a="Analysis">
                            {analyses ? (
                                <Fragment>
                                    <AnalysesList analyses={analyses} />
                                    <Pager
                                        pages={pages}
                                        pageNumber={pageNumber}
                                        onPageChange={this.handlePageClick}
                                    />
                                </Fragment>
                            ) : (
                                ''
                            )}
                        </Can>
                    </div>
                </div>
            );
        }
    }
}

AnalysesBrowser.propTypes = {
    fetchAnalyses: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    failed: PropTypes.bool,
    analyses: PropTypes.array,
    paging: PropTypes.shape({
        pages: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired,
        pageNumber: PropTypes.number.isRequired,
    }),
    search: PropTypes.string,
    setSearch: PropTypes.func,
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { search } = state.search;
    const { fetching, fetched, failed, analyses, paging } = state.analyses;

    return { search, fetching, fetched, failed, analyses, paging };
};

const mapDispatchToProps = dispatch => bindActionCreators({ fetchAnalyses, setSearch }, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(AnalysesBrowser);

// EXPORT COMPONENT
// The unconnected class is exported for tests, as AnalysisEditor and AnalysisPriority do.
export { hoc as AnalysesBrowser, AnalysesBrowser as AnalysesBrowserComponent };
